
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/commentaires-bulletin-neige",
      function () {
        return require("private-next-pages/[region]/[resort]/commentaires-bulletin-neige.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/commentaires-bulletin-neige"])
      });
    }
  